import React from "react";
import { Box, Typography, Container, List, ListItem, ListItemText, Grid } from "@mui/material";
import { SectionHeader } from "components/molecules";

const Policy = ({ title, updatedDate, introduction, sections, className }) => {
    return (
        // <Container maxWidth="md" sx={{ py: 4 }}>

        <div className={className} >
            <Grid
                container
                justify="space-between"
                spacing={2}
            >
                <Grid
                    item
                    container
                    alignItems="center"
                    justify="flex-start"
                    xs={12}
                    data-aos={'fade-up'}
                >
                    <div>
                        <SectionHeader
                            title={title}
                            subtitle={'Last updated: ' + updatedDate}
                            align="left"
                            disableGutter
                            subtitleProps={{
                                color: 'textPrimary',
                                variant: 'body1',
                            }}
                        />
                        <Typography sx={{ mt: 2 }} />
                        { 
                            introduction?.map((text, i) => (
                                <Typography key={i} variant="body1" gutterBottom >
                                    {text}
                                </Typography>
                            ))
                        }

                        {sections.map((section, index) => (
                            <Box key={index} sx={{ mt: 2 }}>
                                <Typography variant="h6" fontWeight="bold">
                                    {section.title}
                                </Typography>
                                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                                    {section.subtitle}
                                </Typography>

                                {section.content.map((para, idx) => {
                                    if (para.type === "title") {
                                        return para.items.map((text, i) => (
                                            <Typography variant="h7" fontWeight="bold">
                                                {text}
                                            </Typography>
                                        ));
                                    }


                                    if (para.type === "text") {
                                        return para.items.map((text, i) => (
                                            <Typography key={i} variant="body1" paragraph>
                                                {text}
                                            </Typography>
                                        ));
                                    }

                                    if (para.type === "bullet") {
                                        return (
                                            <List key={idx} sx={{ listStyleType: 'disc', pl: 4 }}>
                                                {para.items.map((item, i) => (
                                                    <ListItem key={i} sx={{ display: 'list-item', py: 0 }}>
                                                        <ListItemText primary={item} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        );
                                    }

                                    if (para.type === "numbered") {
                                        return (
                                            <List key={idx} sx={{ listStyleType: 'decimal', pl: 4 }}>
                                                {para.items.map((item, i) => (
                                                    <ListItem key={i} sx={{ display: 'list-item', py: 0 }}>
                                                        <ListItemText primary={item} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        );
                                    }

                                    return null;
                                })}
                            </Box>
                        ))}
                    </div>
                </Grid>
            </Grid>
        </div>

    );
};

export default Policy;
